import colors from '../../../../utility/colors';

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    mx: '21px',
    width: '458px',
  },
  countsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '6px',
  },
  count: {
    flex: 1,
    border: `1px solid ${colors.NEUTRAL}`,
    borderRadius: '4px',
    py: '6px',
    textAlign: 'center',
  },
  countValue: {
    color: colors.PRIMARY,
    fontSize: '18px',
    fontWeight: 600,
  },
  countLabel: {
    fontSize: '11px',
    lineHeight: 1.2,
  },
  alert: {
    fontSize: '13px',
    py: 0,
  },
  tableContainer: {
    border: `1px solid ${colors.NEUTRAL}`,
    borderRadius: '4px',
    maxHeight: '240px',
  },
  headerCell: {
    backgroundColor: colors.NEUTRAL_LIGHT,
    fontSize: '12px',
    fontWeight: 600,
    py: '6px',
  },
  cell: {
    fontSize: '12px',
    py: '4px',
    wordBreak: 'break-word',
  },
};

export default styles;
